export default __webpack_public_path__ + "static/media/hht2_ep05_timeline_q04_a.94150774.png";